import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ContactRequest, NewsletterSubscriber } from '../models/catalog.model';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';

export interface ContactPayload {
  name: string;
  email: string;
}

@Injectable({ providedIn: 'root' })
export class ContactService {
  private readonly http = inject(HttpClient);
  private readonly auth = inject(AuthService);
  private readonly baseUrl = environment.apiBaseUrl;

  submit(payload: ContactPayload): Observable<{ id: number }> {
    return this.http.post<{ id: number }>(`${this.baseUrl}/contact`, payload);
  }

  subscribe(email: string): Observable<{ success: boolean }> {
    return this.http.post<{ success: boolean }>(`${this.baseUrl}/newsletter`, {
      email,
    });
  }

  // ------------------------------------------------------------------
  // Admin operations
  // ------------------------------------------------------------------

  adminList(): Observable<ContactRequest[]> {
    return this.http.get<ContactRequest[]>(`${this.baseUrl}/contact`, {
      headers: this.auth.authHeaders(),
    });
  }

  adminDelete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/contact/${id}`, {
      headers: this.auth.authHeaders(),
    });
  }

  adminSubscribers(): Observable<NewsletterSubscriber[]> {
    return this.http.get<NewsletterSubscriber[]>(`${this.baseUrl}/newsletter`, {
      headers: this.auth.authHeaders(),
    });
  }
}
